import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetOffer } from 'slices/offerSlice';
import error from '../../assets/error-request.svg';
import invoice from '../../assets/invoice.svg';

const ErrorContainerConsecutive = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { detail } = useSelector((state) => state.detail);
  const tryAgain = () => {
    navigate(-1);
    dispatch(resetOffer());
  };

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen-mobile-error')[0];
      if (element !== undefined) {
        if (window.scrollY <= 110) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
        }
      }
    });
  };

  useEffect(() => {
    scrollEvent();
  }, []);

  return (
    <>
      <div className="bg-alabaster pt-5 p-sm-3 pb-30 d-block d-sm-none sticky-resumen-mobile-error">
        <div className="wrap">
          <button
            type="button"
            className="header bg-alabaster d-flex justify-content-between btn-link text-left">
            <div className="title opacity-70 ml-2 d-flex">
              <img src={invoice} alt="invoice-img" />
              <h4 className="mt-15 text-bismark ml-3">Confirmación</h4>
            </div>
            <div className="icon-title font-weight-bold text-horizon">
              <i className="fas fa-plus" />
            </div>
          </button>
        </div>
      </div>
      <Container className="bg-white">

        <Row className="pb-60 py-sm-60">
          <Col lg={9} className="text-center">
            <h2 className="mb-15 text-bismark mt-60 mt-sm-0">¡Lo sentimos!</h2>
            <h3>Has ofertado 2 veces consecutivas, espera a que otro socio realice una oferta</h3>
            <img src={error} alt="error-img" />
            <h4 className="mb-30 text-boulder-light">Haz clic para regresar a la subasta.</h4>
            <button type="button" className="btn btn-primary mb-15" id="sbs-dsb-dgr-btn-mor" onClick={tryAgain}>
              Regresar
            </button>
          </Col>
          <Col lg={3} className="opacity-70">
            <div className="bg-alabaster p-3 br-1 d-none d-sm-block">
              <img src={invoice} alt="invoice-img" />
              <h4 className="mt-15 text-bismark">Confirmación</h4>
              <Row className="text-flush-orange ft-12">
                <Col lg={10}>
                  Puntos ofertados
                </Col>
                <Col lg={2}>
                  0
                </Col>
              </Row>
              <h4 className="mt-15 text-bismark">Tu Subasta Premier</h4>
              <h5>{detail.title}</h5>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ErrorContainerConsecutive;
